import { useRef, useMemo } from "react";
import { motion, useInView } from "framer-motion";

const hidden = { opacity: 0, y: 24 };
const visible = { opacity: 1, y: 0 };

export default function ScrollReveal({ children, className = "", delay = 0 }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-80px" });

  const transition = useMemo(
    () => ({ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay }),
    [delay]
  );

  return (
    <motion.div
      ref={ref}
      initial={hidden}
      animate={isInView ? visible : hidden}
      transition={transition}
      className={className}
    >
      {children}
    </motion.div>
  );
}
